// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { lock16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-lock': IconLock;
    }
}

/**
 * The icon component for the 'lock' icon
 */
export class IconLock extends Icon {
    public constructor() {
        super(lock16X16);
    }
}

registerIcon('icon-lock', IconLock);
export const iconLockTag = 'nimble-icon-lock';
